import { DatePicker, Modal, Typography } from "antd";
import { useEffect, useState } from "react";

function ReserveDueModal({ open, onCancel, onConfirm, loading }) {
  const [dueDate, setDueDate] = useState(null);

  useEffect(() => {
    if (open) setDueDate(null);
  }, [open]);

  return (
    <Modal
      title="زیادکردن بۆ جێگرەوە (احتياط)"
      open={open}
      onCancel={onCancel}
      onOk={() => onConfirm(dueDate ? dueDate.format("YYYY-MM-DD") : null)}
      confirmLoading={loading}
      okText="زیادکردن"
      cancelText="پاشگەزبوونەوە"
      centered
    >
      <Typography.Paragraph style={{ marginBottom: 12 }}>
        بەرواری کۆتایی ئارەزوومەندانەیە. ئەگەر چارەخواز دوای ئەو ڕۆژە نەتوانێت بێت، بەروار بنووسە. ئەگەر پێویست نەبوو، بەجێی بهێڵە.
      </Typography.Paragraph>
      <DatePicker
        value={dueDate}
        onChange={setDueDate}
        style={{ width: "100%" }}
        placeholder="بەرواری کۆتایی (ئارەزوومەندانە)"
        inputReadOnly
        allowClear
      />
    </Modal>
  );
}

export default ReserveDueModal;
